import useApi from '../useApi';
import { useShowToast } from '../useShowToast';

export const useFetchPartners = () => {
  const showToast = useShowToast();

  const {
    data: partnersRes,
    loading,
    error,
    postData: getPartners,
  } = useApi('/BlazorApi/dspspartners');

  const fetchPartners = async (id) => {
    const fetchBody = {
      fullName: '',
      businessName: '',
      dspid: id.toString(),
      email: '',
      dob: '',
      primaryContact: '',
      decisionMakingAuthority: '',
      status: '0',
    };
    const res = await getPartners(fetchBody);
    if (res.status) {
      return res.data;
    } else {
      showToast(res.message, 'error');
      return [];
    }
  };

  return { partnersRes, loading, error, fetchPartners };
};
